package com.hyperether.goodjob.repository.remote.auth

import kotlinx.serialization.Serializable

@Serializable
data class GoogleLoginRequest(
    val userId: String?,
    val email: String?,
    val name: String?
)